export { default as Accommodation } from "./accommodation.svg";
export { default as Banned } from "./banned.svg";
export { default as BarChartOff } from "./bar_chart_off.svg";
export { default as Bell } from "./bell.svg";
export { default as Bookmark } from "./bookmark.svg";
export { default as Bookstore } from "./bookstore.svg";
export { default as BubbleChat } from "./bubble_chat.svg";
export { default as BubbleInfo } from "./bubble_info.svg";
export { default as Bus } from "./bus.svg";
export { default as Calendar } from "./calendar.svg";
export { default as CategorySelect } from "./category_select.svg";
export { default as Category } from "./category.svg";
export { default as CheckCircle } from "./check_circle.svg";
export { default as CheckSquare } from "./check_square.svg";
export { default as ChervonDown } from "./chervon_down.svg";
export { default as ChervonLeft } from "./chervon_left.svg";
export { default as ChervonRight } from "./chervon_right.svg";
export { default as ChervonUp } from "./chervon_up.svg";
export { default as ClockReverse } from "./clock_reverse.svg";
export { default as ConvenienceStore } from "./convenience_store.svg";
export { default as Cross } from "./cross.svg";
export { default as Department } from "./department.svg";
export { default as DigitalOutOfHome } from "./digital_out_of_home.svg";
export { default as DoohBot } from "./dooh_bot.svg";
export { default as DoohUser } from "./dooh_user.svg";
export { default as DownloadInquiry } from "./download_inquiry.svg";
export { default as DownloadSolid } from "./download_solid.svg";
export { default as Download } from "./download.svg";
export { default as EditMessage } from "./edit_message.svg";
export { default as EditPencil } from "./edit_pencil.svg";
export { default as FNB } from "./F_n_B.svg";
export { default as FamilyRestroom } from "./family_restroom.svg";
export { default as File } from "./file.svg";
export { default as Filter } from "./filter.svg";
export { default as FloatingPopulation } from "./floating_population.svg";
export { default as Image } from "./image.svg";
export { default as InfoCircle } from "./info_circle.svg";
export { default as Landmark } from "./landmark.svg";
export { default as LightRail } from "./light_rail.svg";
export { default as Link } from "./link.svg";
export { default as Location } from "./location.svg";
export { default as Map } from "./map.svg";
export { default as MediaGroupInformation } from "./media_group_information.svg";
export { default as MediaDooh } from "./media-dooh.svg";
export { default as ParkingLot } from "./parking_lot.svg";
export { default as Plane } from "./plane.svg";
export { default as PriceChange } from "./price_change.svg";
export { default as Profile } from "./profile.svg";
export { default as ReplaceRefresh } from "./replace_refresh.svg";
export { default as SearchInsights } from "./search_insights.svg";
export { default as SearchOff } from "./search_off.svg";
export { default as Search } from "./search.svg";
export { default as Send } from "./send.svg";
export { default as SizeDown } from "./size_down.svg";
export { default as SizeUp } from "./size_up.svg";
export { default as Taxi } from "./taxi.svg";
export { default as Train } from "./train.svg";
export { default as Truck } from "./truck.svg";
export { default as Union } from "./union.svg";
export { default as VehicleMedia } from "./vehicle_media.svg";
export { default as Vehicle } from "./vehicle.svg";
export { default as Warning } from "./warning.svg";

export type IconName = keyof typeof import("./index");
